

export default function Nav() {

    return (
        <div>
            <p className="read-the-docs">
                下载客户端，了解更多访问QQ群：763054634
            </p>
        </div>
    );
}